// https://scotch.io/tutorials/simple-language-translation-in-angular-2-part-2

// lang-es.ts

// 'hello world': 'hello world',
// 'hello greet': 'Hello, %0 %1!',
// 'well done': 'Well done %0',
// 'good bye': 'bye bye',

export const LANG_ES_NAME = "es";

export const LANG_ES_TRANS = {
  LblWeekdays: {
    shorthand: ["LSu", "LMo", "LTu", "LWe", "LTh", "LFr", "LSa"],
    longhand: [
      "LSunday",
      "LMonday",
      "LTuesday",
      "LWednesday",
      "LThursday",
      "LFriday",
      "LSaturday"
    ]
  },
  LblMonths: {
    shorthand: [
      "LJan",
      "LFeb",
      "LMar",
      "LApr",
      "LMay",
      "LJun",
      "LJul",
      "LAug",
      "LSep",
      "LOct",
      "LNov",
      "LDec"
    ],
    longhand: [
      "LJanuary",
      "LFebruary",
      "LMarch",
      "LApril",
      "LMay",
      "LJune",
      "LJuly",
      "LAugust",
      "LSeptember",
      "LOctober",
      "LNovember",
      "LDecember"
    ]
  },
  LblButtonText: {
    today: "LblToday",
    month: "LblMonth",
    week: "LblWeek",
    day: "LblDay",
    list: "LblList"
  },

  // Common Name
  LblEdit: "LblEdit",
  LblDelete: "LblDelete",
  LblRemove: "LblRemove",
  LblActiveInactive: "LblActiveInactive",
  LblActive: "LblActive",
  LblInactive: "LblInactive",
  LblInactiveReason: "LblInactiveReason",
  LblActivityLog: "LblActivityLog",
  LblAddNew: "LblAddNew",
  LblAdd: "LblAdd",
  LblUpdate: "LblUpdate",
  LblSave: "LblSave",
  LblCancel: "LblCancel",
  LblReset: "LblReset",
  LblSelect: "LblSelect",
  LblSuccess: "LblSuccess",
  LblWarning: "LblWarning",
  LblList: "LblList",
  LblAssign: "LblAssign",
  LblHome: "LblHome",
  LblYes: "LblYes",
  LblOK: "LblOK",
  LblNo: "LblNo",
  LblBack: "LblBack",
  LblReason: "LblReason",
  LblApprovalAdminName: "LblApprovalAdminName",
  LblRecordSavedSuccess: "LblRecordSavedSuccess",
  LblRecordDeleteSuccess: "LblRecordDeleteSuccess",
  LblResetPasswordSuccess: "LblResetPasswordSuccess",
  LblConfirm: "LblConfirm",
  LblBlockUnblockConfirm: "LblBlockUnblockConfirm",
  LblRecordDeleteConfirmation: "LblRecordDeleteConfirmation",
  LblRecordMultiplDeleteConfirmation: "LblRecordMultiplDeleteConfirmation",
  LblConfirmMessage: "LblConfirmMessage",
  LblResetPassword: "LblResetPassword",
  LblResetPasswordConfirmation: "LblResetPasswordConfirmation",
  LblGeoLocationError: "LblGeoLocationError",
  LblPersonDeleteCheck: "LblPersonDeleteCheck",
  LblBookingCancelSuccess: "LblBookingCancelSuccess",
  LblBookingAbortSuccess: "LblBookingAbortSuccess",
  LblBookingRevokeSuccess: "LblBookingRevokeSuccess",
  LblContactPersonRemoveSuccess: "LblContactPersonRemoveSuccess",
  LblContactPersonAddedSuccess: "LblContactPersonAddedSuccess",
  LblNoRecords: "LblNoRecords",
  LblAffectedBookingList: "LblAffectedBookingList",
  LblSubscriptionEndDateError: "LblSubscriptionEndDateError",
  LblIsSpecialPeriodAllow: "LblIsSpecialPeriodAllow",
  LblContractSlotisnotdefined: "LblContractSlotisnotdefined",
  LblUnscubscribeSuccess: "LblUnscubscribeSuccess",
  LblModifiedBy: "LblModifiedBy",
  LblModifiedDate: "LblModifiedDate",
  LblContractTypeGroupAvailableForSubscription:
    "LblContractTypeGroupAvailableForSubscription",

  LblRemoveContactPersonConfirm: "LblRemoveContactPersonConfirm",
  LblBookingApproveRejectSuccess: "LblBookingApproveRejectSuccess",
  LblRecordAddedSuccess: "LblRecordAddedSuccess",
  LblRecordUpdatedSuccess: "LblRecordUpdatedSuccess",
  LblRecordRemovedSuccess: "LblRecordRemovedSuccess",
  LblRecordActiveInActiveSuccess: "LblRecordActiveInActiveSuccess",
  LblinvoiceResendSuccess: "LblinvoiceResendSuccess",
  LblRecordBlokUnBlockSuccess: "LblRecordBlokUnBlockSuccess",
  LblEditPage: "LblEditPage",
  LblAddPage: "LblAddPage",
  LblListPage: "LblListPage",
  LblKilometers: "LblKilometers",
  LblKM: "LblKM",

  //'LblRecordUnBlockedSuccess':'unBlocked successfully',
  //MobileApp Configuration
  LblMobileAppConfiguration: "LblMobileAppConfiguration",
  LblEnableNewBooking: "LblEnableNewBooking",
  LblEnableBookingCalender: "LblEnableBookingCalender",
  LblEnableSubscription: "LblEnableSubscription",
  LblEnableUpdateProfile: "LblEnableUpdateProfile",
  LblEnableNotification: "LblEnableNotification",
  LblEnableChangeBooking: "LblEnableChangeBooking",
  LblEnableAddExpenseMenu: "LblEnableAddExpenseMenu",

  //Instance Clone
  LblInstanceClone: "LblInstanceClone",
  LblNewInstanceName: "LblNewInstanceName",
  LblCloneResult: "LblCloneResult",
  LblCloneStatus: "LblCloneStatus",
  CloneError: "CloneError",

  //Booking Type
  LblNORMALBOOKINGTYPE: 'LblNORMALBOOKINGTYPE',
  LblMAINTENANCEBOOKINGTYPE: 'LblMAINTENANCEBOOKINGTYPE',
  LblUNAVAILABLEBOOKINGTYPE: 'LblUNAVAILABLEBOOKINGTYPE',

  //Booking Request Status
  LblAPPROVEDBOOKINGREQUEST: 'LblAPPROVEDBOOKINGREQUEST',
  LblREJECTEDBOOKINGREQUEST: 'LblREJECTEDBOOKINGREQUEST',
  LblPENDINGBOOKINGREQUEST: 'LblPENDINGBOOKINGREQUEST',

  //Booking Status
  LblABORTED: 'LblABORTED',
  LblCANCELLED: 'LblCANCELLED',
  LblCONFIRMED: 'LblCONFIRMED',
  LblFINISHED: 'LblFINISHED',
  LblNOSHOW: 'LblNOSHOW',
  LblPENDING: 'LblPENDING',
  LblREVOKED: 'LblREVOKED',
  LblRUNNING: 'LblRUNNING',
  LblREADYFORPAYMENT: 'LblREADYFORPAYMENT',

  //Invoice Status
  LblOPEN: 'LblOPEN',
  LblSENT: 'LblSENT',
  LblCLOSED: 'LblCLOSED',
  LblREQUESTFORPAYMENT: 'LblREQUESTFORPAYMENT',
  LblREOPEN: 'LblREOPEN',

  // Error Log
  LblErrorLog: "LblErrorLog",
  LblComponentName: "LblComponentName",
  LblLogType: "LblLogType",
  LblEventDateTime: "LblEventDateTime",

  //ErrorEscalation
  LblDuplicateErrorEscalation: "LblDuplicateErrorEscalation",
  LblErrorEscalation: "LblErrorEscalation",
  LblComponent: "Component",
  LblSelectAdminLevel: "LblSelectAdminLevel",
  LblWegoAdminLevel: "LblWegoAdminLevel",
  LblCustomerAdminLevel: "LblCustomerAdminLevel",
  LblInstanceAdminLevel: "LblInstanceAdminLevel",

  // Interface Status
  LblInterfaceStatus: "LblInterfaceStatus",
  LblLastStatusChangeDateTime: "LblLastStatusChangeDateTime",
  LblWegoAdminDependencyValidation:
    "Wego Admin Can not be deleted because it is associated with other entity.",
  LblLastCarwisePollDateTime: "LblLastCarwisePollDateTime",
  LblUpdatedDateTime: "LblUpdatedDateTime",
  LblMonitoring: "LblMonitoring",
  LblEnableLogin: "LblEnableLogin",
  LblEnableErrorEscalation: "LblEnableErrorEscalation",
  LblErrorEscalationMinutes: "LblErrorEscalationMinutes",

  //Instance Page
  LblCarwiseEnable: "LblCarwiseEnable",
  LblAdminDependencyValidationOnDelete: "LblAdminDependencyValidationOnDelete",
  LblAdminDependencyValidation:
    "LblAdminDependencyValidation",
  LblAdminDependencyAlert: "LblAdminDependencyAlert",
  LblCarwiseConfiguration: "LblCarwiseConfiguration",
  LblCarwiseConnectionUrl: "LblCarwiseConnectionUrl",
  LblCarwiseConnectionUsername: "LblCarwiseConnectionUsername",
  LblCarwiseConnectionPassword: "LblCarwiseConnectionPassword",
  LblCarwiseAutoDeleteFrequencyInDays: "LblCarwiseAutoDeleteFrequencyInDays",
  LblDamageImageExtentions: "LblDamageImageExtentions",
  LblInstance: "LblInstance",
  LblInstanceName: "LblInstanceName",
  LblInstanceType: "LblInstanceType",
  LblDescription: "LblDescription",
  LblCurrencySymbol: "LblCurrencySymbol",
  LblPreferredLanguage: "LblPreferredLanguage",
  LblTimeZone: "LblTimeZone",
  LblCurrencyAbbreviation: "LblCurrencyAbbreviation",
  LblInstanceDeleteValidation: "LblInstanceDeleteValidation",
  LblIsBookingApprovalReq: "LblIsBookingApprovalReq",
  LblInstanceConfiguration: "LblInstanceConfiguration",
  LblBookingAlertTime: "LblBookingAlertTime",
  LblBookingCancelTime: "LblBookingCancelTime",
  LblBookingTemporaryTime: "LblBookingTemporaryTime",
  LblVtsRequestTimeout: "LblVtsRequestTimeout",
  LblVtsTripLogTimeout: "LblVtsTripLogTimeout",
  LblEmailConfiguration: "LblEmailConfiguration",
  LblInSeconds: "LblInSeconds",
  LblFromEmail: "LblFromEmail",
  LblHost: "LblHost",
  LblPort: "LblPort",
  LblEnableSsl: "LblEnableSsl",
  LblSmtpEmail: "LblSmtpEmail",
  LblBookingCancelTimeMessage: "LblBookingCancelTimeMessage",
  LblBookingTemporaryTimeMessage: "LblBookingTemporaryTimeMessage",
  LblVtSRequestTimeoutMessage: "LblVtSRequestTimeoutMessage",
  LblVtsTriplogTimeoutMessage: "LblVtsTriplogTimeoutMessage",
  LblContractTypeDeleteValidation: "LblContractTypeDeleteValidation",
  LblSelectFuelType: "LblSelectFuelType",
  LblSelectPricingCatagory: "LblSelectPricingCatagory",
  LblSelectBodyStyle: "LblSelectBodyStyle",
  LblSelectVehicleClass: "LblSelectVehicleClass",
  LblIsImportPersonAllow: "LblIsImportPersonAllow",
  LblValidateLiceanceNumber: "LblValidateLiceanceNumber",
  LblGeofenceLocation: "LblGeofenceLocation",
  LblRadius: "LblRadius",
  LblEmailRecepients: "LblEmailRecepients",
  LblRecepients: "LblRecepients",
  LblEmailAddresses: "LblEmailAddresses",
  LblMap: "LblMap",

  // AFAS/Azure Config
  LblImportConfiguration: "Import Configuration",
  LblImportConnectionType: "Connection Type",
  LblAfas: "AFAS",
  LblAzure: "Azure",
  LblAzureTenantId: "Azure Tenant ID",
  LblAzureClientId: "Azure Client ID",
  LblAzureClientSecret: "Azure Client Secret",
  LblAfasClientId: "AFAS Client ID",
  LblAfasConnectorName: "AFAS Connector Name",
  LblAfasConnectionType: "AFAS Connection Type",
  LblAfasTest: "Test",
  LblAfasAccept: "Acceptation",
  LblAfasProduction: "Production",
  LblAfasToken: "AFAS Token",
  LblAfasClientIdError: "Please enter AFAS Client ID",
  LblAfasConnectorNameError: "Please enter AFAS Client ID",
  LblAfasConnectionTypeError: "Please enter AFAS Connection Type",
  LblAfasTokenError: "Please enter AFAS-Token",
  LblAzureTenantIdError: "Please enter Azure Tenant ID",
  LblAzureClientIdError: "Please enter Azure Client ID",
  LblAzureClientSecretError: "Please enter Azure Client Secret",

  // SSO Config
  LblSsoConfiguration: "SSO Configuration",
  LblDefaultSsoSharedVehicleGroup: "Default Shared Vehicle Group",
  LblDefaultSsoOrganization: "Default Organization",
  LblDefaultSsoSubscription: "Default Subscription",

  // Dropoff Message
  LblDropoffMessageConfiguration: "Dropoff Message Configuration",
  LblDropoffMessageExternalUrl: "External Url",
  LblDropoffMessageApiKey: "Api Key",
  LblDropoffMessageActive: "Active",

  LblValidate: "LblValidate",

  LblBookingCalanderSettings: "LblBookingCalanderSettings",
  LblShowDriverInfo: "LblShowDriverInfo",
  LblOrganizationAdmin: "LblOrganizationAdmin",
  LblDriverInfoToShow: "LblDriverInfoToShow",

  //Person Page
  LblUserName: "LblUserName",
  LblFirstName: "LblFirstName",
  LblLastName: "LblLastName",
  LblEmail: "LblEmail",
  LblMobileNumber: "LblMobileNumber",
  LblPhoneNumber: "LblPhoneNumber",
  LblHomeAddress: "LblHomeAddress",
  LblWorkAddress: "LblWorkAddress",
  LblHouseNo: "LblHouseNo",
  LblHouseExtention: "LblHouseExtention",
  LblStreetName: "LblStreetName",
  LblCity: "LblCity",
  LblZipCode: "LblZipCode",
  LblPassword: "LblPassword",
  LblConfirmPassword: "LblConfirmPassword",
  LblMiddleName: "LblMiddleName",
  LblMandateId: "LblMandateId",
  LblMandateSignatureDate: "LblMandateSignatureDate",
  LblIsAmmandment: "LblIsAmmandment",
  LblRemovePersonDetails: "LblRemovePersonDetails",

  //Company Page
  LblCompany: "LblCompany",
  LblCompanyName: "LblCompanyName",
  LblContactPerson: "LblContactPerson",
  LblCompanyAdmin: "LblCompanyAdmin",
  LblCompanyAddress: "LblCompanyAddress",
  LblInternalOrganization: "LblInternalOrganization",
  LblNoOfVegicles: "LblNoOfVegicles",
  LblNoOfSharedVehicleGroups: "LblNoOfSharedVehicleGroups",
  LblGeoLocation: "LblGeoLocation",
  LblSelectGeoLocation: "LblSelectGeoLocation",
  LblPerson: "LblPerson",
  LblRole: "LblRole",
  LblDateOfBirth: "LblDateOfBirth",
  LblDriverLicenceNumber: "LblDriverLicenceNumber",
  LblApkExiprationSetting: "LblApkExiprationSetting",
  LblApkTimeInterval: "LblApkTimeInterval",
  LblEmailNotification: "LblEmailNotification",
  LblNotificationFrequency: "LblNotificationFrequency",
  lblThresholdFrequency: "lblThresholdFrequency",
  lblThresholdTimeInterval: "lblThresholdTimeInterval",
  LblIsEmailEnabled: "LblIsEmailEnabled",
  lblThreshold: "lblThreshold",
  LblFrequency: "LblFrequency",
  LblDay: "LblDay",
  LblWeek: "LblWeek",
  LblMonth: "LblMonth",
  lblPerBooking: "lblPerBooking",
  LblPersons: "LblPersons",
  LblPersonOverview: "LblPersonOverview",
  LblCompanies: "LblCompanies",
  //Vehicle Page
  LblVehicle: "LblVehicle",
  LblVtsVehicle: "LblVtsVehicle",
  LblFleetId: "LblFleetId",
  LblContractId: "LblContractId",
  LblVIN: "LblVIN",
  LblLicenceTag: "LblLicenceTag",
  LblLicence: "LblLicence",
  LblMobile: "LblMobile",
  LblVehicleOwner: "LblVehicleOwner",
  LblLocationDataExchange: "LblLocationDataExchange",
  LblBrand: "LblBrand",
  LblType: "LblType",
  LblColor: "LblColor",
  LblVehicleClass: "LblVehicleClass",
  LblPricingCategory: "LblPricingCategory",
  LblBodyStyle: "LblBodyStyle",
  LblAvailable: "LblAvailable",
  LblUnAvailable: "LblUnAvailable",
  LblAvailableFrom: "LblAvailableFrom",
  LblAvailableTo: "LblAvailableTo",
  LblFuelType: "LblFuelType",
  LblMinBookingTimeBefore: "LblMinBookingTimeBefore",
  LblMinBookingTimeAfter: "LblMinBookingTimeAfter",
  LblTowbar: "LblTowbar",
  LblAirco: "LblAirco",
  LblVehicleAttributes: "LblVehicleAttributes",
  LblBlockUnBlock: "LblBlockUnBlock",
  LblRemoveLicense: "LblRemoveLicense",
  LblLicenseBirthDate: "LblLicenseBirthDate",
  LblRemoveLicenseBirthDate: "LblRemoveLicenseBirthDate",
  LblBlock: "LblBlock",
  LblUnblock: "LblUnblock",
  LblAvailableUnAvailable: "LblAvailableUnAvailable",
  LblVehicles: "LblVehicles",
  LblBookingsOverview: "LblBookingsOverview",
  LblApkExpirationDateCet: "LblApkExpirationDateCet",
  LblEnabled: "LblEnabled",
  LblDisabled: "LblDisabled",
  LblIntialOdometerValue: "LblIntialOdometerValue",
  LblFuelCardPinCode: "LblFuelCardPinCode",

  //WEGO2DEV-325(Settings for Dashboard statuses)
  LblVehicleOnSameLocationTime: "LblVehicleOnSameLocationTime",
  LblNoBookingIn: "LblNoBookingIn",
  lblHour: "lblHour",
  //'lblInterval':'HOUR/DAY/WEEK/MONTH',
  lblHourDayWeekMonth: "lblHourDayWeekMonth",

  //SharedVehicleGroup
  LblSharedVehicleGroup: "LblSharedVehicleGroup",
  LblVehicleGroup: "LblVehicleGroup",
  LblSharedVehicleGroupAdmin: "LblSharedVehicleGroupAdmin",
  LblDisplayPeriod: "LblDisplayPeriod",
  LblBookingWeekDays: "LblBookingWeekDays",
  LblBookingInterval: "LblBookingInterval",
  LblBookingStartTime: "LblBookingStartTime",
  LblBookingEndTime: "LblBookingEndTime",
  LblBookingMinDuration: "LblBookingMinDuration",
  LblBookingMaxDuration: "LblBookingMaxDuration",
  LblMaxRecurringBooking: "LblMaxRecurringBooking",
  LblPreBookingInterval: "LblPreBookingInterval",
  LblPostBookingInterval: "LblPostBookingInterval",
  LblBookingExtensionTime: "LblBookingExtensionTime",
  LblBookAheadTime: "LblBookAheadTime",
  LblBookingHorizon: "LblBookingHorizon",
  LblNumberOfContactTypeGroup: "LblNumberOfContactTypeGroup",
  LblNumberOfContactType: "LblNumberOfContactType",
  LblInvoiceInterval: "LblInvoiceInterval",
  LblIsBookingIntervalAlignToCalendar: "LblIsBookingIntervalAlignToCalendar",
  LblBookings: "LblBookings",
  LblSharedVehicleGroups: "LblSharedVehicleGroups",
  LblSharedVehicleGroupOverview: "LblSharedVehicleGroupOverview",
  LblEarlyOpenInterval: "LblEarlyOpenInterval",

  //Driver
  LblDriver: "LblDriver",
  LblLicenceNumber: "LblLicenceNumber",
  LblDriverName: "LblDriverName",
  LblDriverSVG: "LblDriverSVG",
  LblDriverUserName: "LblDriverUserName",

  //VehicleAttribute
  LblVehicleAttributeCategory: "LblVehicleAttributeCategory",
  LblVehicleAttributeName: "LblVehicleAttributeName",
  LblVehicleAttributeDesc: "LblVehicleAttributeDesc",
  LblVehicleAttribute: "LblVehicleAttribute",
  LbAdditionallVehicleAttribute: "LbAdditionallVehicleAttribute",
  LblVehicleAttributeCategories: "LblVehicleAttributeCategories",

  //ContractType Page
  LblRegular: "LblRegular",
  LblWeekEnd: "LblWeekEnd",
  LblDayCT: "LblDayCT",
  LblExtraTimeBefore: "LblExtraTimeBefore",
  LblExtraTimeAfter: "LblExtraTimeAfter",
  LblFreeTextDescription: "LblFreeTextDescription",
  LblPeriodRate: "LblPeriodRate",
  LblPeriodRateVat: "LblPeriodRateVat",
  LblSelectContractTypeType: "LblSelectContractTypeType",
  LblContractTypeType: "LblContractTypeType",
  LblContractType: "LblContractType",
  LblContractName: "LblContractName",
  LblContractTypeGroup: "LblContractTypeGroup",
  LblContractTypeGroupName: "LblContractTypeGroupName",
  LblContractAvailableDays: "LblContractAvailableDays",
  LblApplicableDays: "LblApplicableDays",
  LblDayStartTime: "LblDayStartTime",
  LblDayEndTime: "LblDayEndTime",
  LblApplicableStartTime: "LblApplicableStartTime",
  LblApplicableEndTime: "LblApplicableEndTime",
  LblComment: "LblComment",
  LblProcessingFee: "LblProcessingFee",
  LblVatPercentage: "LblVatPercentage",
  LblVatIncludedInPrice: "LblVatIncludedInPrice",
  LblPlateformUsageCost: "LblPlateformUsageCost",
  LblCatA: "LblCatA",
  LblCatB: "LblCatB",
  LblCatC: "LblCatC",
  LblCatD: "LblCatD",
  LblCatE: "LblCatE",
  LblCatF: "LblCatF",
  LblCatG: "LblCatG",
  LblCatH: "LblCatH",
  LblHourlyRate: "LblHourlyRate",
  LblMileageRate: "LblMileageRate",
  LblFixedFee: "LblFixedFee",
  LblPricingModel: "LblPricingModel",
  LblContractStartDateTime: "LblContractStartDateTime",
  LblContractEndDateTime: "LblContractEndDateTime",
  LblContractTypeHistory: "LblContractTypeHistory",
  LblContractTypPeriod: "LblContractTypPeriod",
  LblInactiveContractTypeGroupReason: "LblInactiveContractTypeGroupReason",
  LblPenaltyAmount: "LblPenaltyAmount",
  LblPenaltyTimeInterval: "LblPenaltyTimeInterval",
  LblIsPenaltyEnabled: "LblIsPenaltyEnabled",
  LblTripDisplayType: "LblTripDisplayType",
  LblAllTripsIndividually: "LblAllTripsIndividually",
  LblAllTripsGrouped: "LblAllTripsGrouped",

  // DateTime Picker
  LblJanuary: "LblJanuary",
  LblFebruary: "LblFebruary",
  LblMarch: "LblMarch",
  LblApril: "LblApril",
  LblMay: "LblMay",
  LblJune: "LblJune",
  LblJuly: "LblJuly",
  LblAugust: "LblAugust",
  LblSeptember: "LblSeptember",
  LblOctober: "LblOctober",
  LblNovember: "LblNovember",
  LblDecember: "LblDecember",

  LblSJan: "LblSJan",
  LblSFeb: "LblSFeb",
  LblSMar: "LblSMar",
  LblSApr: "LblSApr",
  LblSMay: "LblSMay",
  LblSJun: "LblSJun",
  LblSJul: "LblSJul",
  LblSAug: "LblSAug",
  LblSSep: "LblSSep",
  LblSOct: "LblSOct",
  LblSNov: "LblSNov",
  LblSDec: "LblSDec",

  LblSunday: "LblSunday",
  LblMonday: "LblMonday",
  LblTuesday: "LblTuesday",
  LblWednesday: "LblWednesday",
  LblThursday: "LblThursday",
  LblFriday: "LblFriday",
  LblSaturday: "LblSaturday",

  LblSSu: "LblSSu",
  LblSMo: "LblSMo",
  LblSTu: "LblSTu",
  LblSWe: "LblSWe",
  LblSTh: "LblSTh",
  LblSFr: "LblSFr",
  LblSSa: "LblSSa",

  //Forgot Password
  LblForgotPassword: "LblForgotPassword",
  LblChangePassword: "LblChangePassword",
  LblOldPassword: "LblOldPassword",
  LblNewPassword: "LblNewPassword",
  LblProfileUpdatedSucessFully: "LblProfileUpdatedSucessFully",
  LblPasswordChangedSucessFully: "LblPasswordChangedSucessFully",

  //
  LblUpdateProfile: "LblUpdateProfile",
  LbLReasonVehicle: "LbLReasonVehicle",
  LblReasonDriver: "LblReasonDriver",

  //Booking
  LblFrom: "LblFrom",
  LblTo: "LblTo",
  LblBooking: "LblBooking",
  LblBookingRequest: "LblBookingRequest",
  LblOverview: "LblOverview",
  LblOverviewList: "LblOverviewList",
  LblApproveBooking: "LblApproveBooking",
  LblApprove: "LblApprove",
  LblReject: "LblReject",
  LblNormal: "LblNormal",
  LblSpecial: "LblSpecial",
  LblHistory: "LblHistory",
  LblBookingStatus: "LblBookingStatus",
  LblBookingType: "LblBookingType",
  LblAdminRemarks: "LblAdminRemarks",
  LblBookingRemarks: "LblBookingRemarks",
  LblDriverRemarks: "LblDriverRemarks",
  LblBookingReferenceId: "LblBookingReferenceId",
  LblAbort: "LblAbort",
  LblRevoke: "LblRevoke",
  LblStatus: "LblStatus",
  LblReference: "LblReference",
  LblRemarks: "LblRemarks",
  LblSearchForVehicle: "LblSearchForVehicle",
  LblVehicleOverview: "LblVehicleOverview",
  LblConfirmBooking: "LblConfirmBooking",
  LblCurrentBookingDetail: "LblCurrentBookingDetail",
  LblCheckAvailability: "LblCheckAvailability",
  LblBookingStartDateTime: "LblBookingStartDateTime",
  LblBookingEndDateTime: "LblBookingEndDateTime",
  LblSource: "LblSource",
  LblRecurring: "LblRecurring",
  LblRecurringId: "LblRecurringId",
  LblRecurringBookingReference: "LblRecurringBookingReference",
  LblDaily: "LblDaily",
  LblWeekly: "LblWeekly",
  LblMonthly: "LblMonthly",
  LblRecurrenceEndDate: "LblRecurrenceEndDate",
  LblSearch: "LblSearch",
  LblBookNow: "LblBookNow",
  LblUpdateBooking: "LblUpdateBooking",
  LblEditCarNotAvailable: "LblEditCarNotAvailable",
  LblSortBy: "LblSortBy",
  LblAvaibility: "LblAvaibility",
  LblDistance: "LblDistance",
  LblNoMatchingVehicle: "LblNoMatchingVehicle",
  LblAvailableSlots: "LblAvailableSlots",
  LblFeatures: "LblFeatures",
  LblDriverDetail: "LblDriverDetail",
  LblBookingDetail: "LblBookingDetail",
  LblVehicleDetail: "LblVehicleDetail",
  LblBookingSuccess: "LblBookingSuccess",
  LblBookingUpdateSuccess: "LblBookingUpdateSuccess",
  LblBlockNormalBooking: "LblBlockNormalBooking",
  LblSingle: "LblSingle",
  LblSeries: "LblSeries",
  LblAll: "LblAll",
  LblLicenceRequired1: "LblLicenceRequired1",
  LblLicenceRequired2: "LblLicenceRequired2",

  //Special Booking
  LblSpecialBooking: "LblSpecialBooking",
  LblAffectedBooking: "LblAffectedBooking",
  LblSpecialBookingType: "LblSpecialBookingType",
  LblSelectSpecialBookingType: "LblSelectSpecialBookingType",
  LblSpecialBookingConfiramtionmsg: "LblSpecialBookingConfiramtionmsg",
  LblEndDate: "LblEndDate",

  // Notification
  LblNotification: "LblNotification",
  LblSubject: "LblSubject",
  LblDate: "LblDate",
  LblWelcomeNotification: "LblWelcomeNotification",

  //Template
  LblTemplate: "LblTemplate",
  LblTemplateList: "LblTemplateList",
  LblTemplateName: "LblTemplateName",
  LblTemplateType: "LblTemplateType",
  LblBody: "LblBody",
  LblIsEmailTemplate: "LblEmail",
  LblIsWebTemplate: "LblWeb",

  // Notification Event Management
  LblNotificationEventManagement: "LblNotificationEventManagement",
  LblNotificationEvent: "LblNotificationEvent",
  LblModuleName: "LblModuleName",
  LblSMS: "LblSMS",
  //User Type
  LblUserType: "LblUserType",

  //TimeBlock

  LblTimeBlock: "LblTimeBlock",
  LblTimeBlockName: "LblTimeBlockName",
  LblTimeBlockWeekDays: "LblTimeBlockWeekDays",
  LblTimeBlockStartTime: "LblTimeBlockStartTime",
  LblTimeBlockEndTime: "LblTimeBlockEndTime",
  LblTimeBlockStartDate: "LblTimeBlockStartDate",
  LblTimeBlockEndDate: "LblTimeBlockEndDate",

  // Service Offer
  LblServiceOffer: "LblServiceOffer",
  LblServiceOfferList: "LblServiceOfferList",
  LblServiceOfferName: "LblServiceOfferName",
  LblServiceOfferType: "LblServiceOfferType",

  LblStandardTariff: "LblStandardTarifff",
  LblTimeUsedOrBooked: "LblTimeUsedOrBooked",
  LblPenalty: "LblPenalty",
  LblAdditional: "LblAdditional",
  LblAdditionalAbbr: "LblAdditionalAbbr",
  LblUnit: "LblUnit",

  //WegoAdminList
  LblWegoAdmin: "LblWegoAdmin",
  LblWegoAdmins: "LblWegoAdmins",

  LblReSend: "LblReSend",
  LblResendActivationMail: "LblResendActivationMail",
  LblResendActivationMailFailure: "LblResendActivationMailFailure",
  LblResendActivationMailSuccess: "LblResendActivationMailSuccess",

  //Subscription
  LblSubscription: "LblSubscription",
  LblSubscriptionName: "LblSubscriptionName",
  LblTimeInterval: "Time Interval",
  LblAmount: "LblAmount",
  LblFreeKilometer: "LblFreeKilometer",
  LblFreeMinute: "LblFreeMinute",
  LblFreeHours: "LblFreeHours",
  LblNumberOfSubscription: "LblNumberOfSubscription",
  LblUnsubscribe: "LblUnsubscribe",
  LblsubscribeEndDate: "LblsubscribeEndDate",
  LblSubscriptionStartDate: "LblSubscriptionStartDate",
  //Special Period
  LblSpecialPeriod: "LblSpecialPeriod",
  LblspecialPeriodName: "LblspecialPeriodName",
  LblSpecialPeriodStartTime: "LblSpecialPeriodStartTime",
  LblSpecialPeriodEndTime: "LblSpecialPeriodEndTime",
  LblSpecialPeriodWeekDays: "LblSpecialPeriodWeekDays",
  LblNormalPeriod: "LblNormalPeriod",
  LblSpecialPeriods: "LblSpecialPeriods",
  //Booking InvoiceModel
  LblBookingInvoice: "LblBookingInvoice",
  LblInvoiceStatus: "LblInvoiceStatus",
  LblInvoiceType: "LblInvoiceType",
  LblSummary: "LblSummary",
  LblTotalHours: "LblTotalHours",
  LblTotalKm: "LblTotalKm",
  LblTotalExpense: "LblTotalExpense",
  LblInvoiceNumber: "LblInvoiceNumber",
  LblBegin: "LblBegin",
  LblEnd: "LblEnd",
  LblVat: "VAT",
  LblDone: "LblDone",
  LblClear: "LblClear",
  LblTotal: "LblTotal",
  LblInvoiceRequestDateTime: "LblInvoiceRequestDateTime",
  LblInvoiceSendDateTime: "LblInvoiceSendDateTime",
  LblInvoiceDateTime: "LblInvoiceDateTime",
  LblInvoiceDetail: "LblInvoiceDetail",
  LblResend: "LblResend",
  LblDownload: "LblDownload",
  LblResendInvoiceConfirm: "LblResendInvoiceConfirm",
  LblSendInvoiceConfirm: "LblSendInvoiceConfirm",
  LblPenaltyRate: "LblPenaltyRate",
  LblInvoicing: "LblInvoicing",
  LblInvoices: "LblInvoices",

  LblProfile: "LblProfile",
  LblSignOut: "LblSignOut",
  LblTemplateNote1: "LblTemplateNote1",
  LblTemplateNote2: "LblTemplateNote2",
  LblTemplateNote3: "LblTemplateNote3",
  LblConfirmUnsubscribe: "LblConfirmUnsubscribe",
  LblDriveHours: "LblDriveHours",
  LblVehicleImage: "LblVehicleImage",
  LblMaintenance: "LblMaintenance",
  LblUNAVAILABLE: "LblUNAVAILABLE",
  LblTestInvoiceGenerator: "LblTestInvoiceGenerator",
  LblMissingInvoiceGenerator: "Missing Invoice Generator",
  LblInvoicingDateTime: "LblInvoicingDateTime",
  LblGenerateInvoice: "LblGenerateInvoice",
  LblDeleteAllSelectedRecords: "LblDeleteAllSelectedRecords",
  LblCancelAllSelectedRecords: "LblCancelAllSelectedRecords",
  "LblExportAll(CSV)": "LblExportAll(CSV)",
  LblAddContactPerson: "LblAddContactPerson",
  LblRemoveContactPerson: "LblRemoveContactPerson",
  LblNote: "LblNote",
  LblCompletelyEndConfirm: "LblCompletelyEndConfirm",
  LblEndTrip: "LblEndTrip",
  LblTestTrip: "LblTestTrip",
  LblTripSimulator: "LblTripSimulator",
  LblPrePostTripQuestions: "LblPrePostTripQuestions",
  LblTestTripSuccess: "LblTestTripSuccess",
  LblDrivingStartDateTime: "LblDrivingStartDateTime",
  LblDrivingEndDateTime: "LblDrivingEndDateTime",
  LblInvoiceMoment: "LblInvoiceMoment",
  LblExtend: "LblExtend",
  LblExtendRequire: "LblExtendRequire",
  LblExtendInfoMsg: "LblExtendInfoMsg",
  LblExtendValidationMsg: "LblExtendValidationMsg",
  LblExtendBooking: "LblExtendBooking",
  LblBookingExtendedSuccess: "LblBookingExtendedSuccess",
  LblOverExtendValidationMsg: "LblOverExtendValidationMsg",
  LblUnLock: "LblUnLock",
  LblLock: "LblLock",
  LblVehicleStatus: "LblVehicleStatus",
  LblTripSuccess: "LblTripSuccess",

  LblLockSuccessfully: "LblLockSuccessfully",
  LblLockCompletelySuccessfully: "LblLockCompletelySuccessfully",
  LblUnLockSuccessfully: "LblUnLockSuccessfully",
  LblUnlockProblem: "LblUnlockProblem",
  LbllockProblem: "LbllockProblem",
  LblLockCarCompletely: "LblLockCarCompletely",
  LblStartDateTime: "LblStartDateTime",
  LblEndDateTime: "LblEndDateTime",
  LblBookingTripDetail: "LblBookingTripDetail",
  LblAddNewTrip: "LblAddNewTrip",
  LblBookingExpenseDetail: "LblBookingExpenseDetail",
  LblUnlockErrorMessage: "LblUnlockErrorMessage",
  LblExpenseAmount: "LblExpenseAmount",
  LblExpenseName: "LblExpenseName",
  LblExpenseSuccess: "LblExpenseSuccess",
  LblReceipt: "LblReceipt",
  LblHelpdeskNo: "LblHelpdeskNo",
  LblBookingExpired: "LblBookingExpired",
  LblTripCalculationInProgress: "LblTripCalculationInProgress",

  LblVTSReqLogDetail: "LblVTSReqLogDetail",
  LblVTSReqDateTime: "LblVTSReqDateTime",
  LblVTSProcessTime: "LblVTSProcessTime",
  LblVTSResTime: "LblVTSResTime",
  LblVTSReqType: "LblVTSReqType",
  LblVTSResult: "LblVTSResult",
  LblActualInvoiceGenerationDate: "LblActualInvoiceGenerationDate",
  LblAvailableForAllSlots: "LblAvailableForAllSlots",
  LblUnAvailableSlots: "LblUnAvailableSlots",
  LblNoOfDrivers: "LblNoOfDrivers",
  LblSVGDriversList: "LblSVGDriversList",
  LblVehicleInformation: "LblVehicleInformation",
  LblVTSVehicle: "LblVTSVehicle",
  LblVTSVehicleUpdateSuccess: "LblVTSVehicleUpdateSuccess",
  LblVTSVehicleList: "LblVTSVehicleList",
  //Report Damage
  LblReportDamage: "LblReportDamage",
  LblCompleteDamageReport: "LblCompleteDamageReport",
  LblDamageFile: "LblDamageFile",
  LblDescribe: "LblDescribe",
  LblCause: "LblCause",
  LblReportDamageMsg: "LblReportDamageMsg",
  LblSelectFile: "LblSelectFile",

  // Import Data
  LblCSVImport: "LblCSVImport",
  LblValidateCSV: "LblValidateCSV",
  LblImportValidPerson: "LblImportValidPerson",
  LblImportValidDriver: "LblImportValidDriver",
  LblImportValidVehicle: "LblImportValidVehicle",
  LblCSVType: "LblCSVType",
  LblCSVFile: "LblCSVFile",
  LblRecordImportedSuccess: "LblRecordImportedSuccess",
  LblInvalidReason: "LblInvalidReason",
  LblSameVTSCommand: "LblSameVTSCommand",
  LblImportPerson: "LblImportPerson",

  //Subscription related Changes
  LblSubscriptionInterval: "LblSubscriptionInterval",
  LblPaymentInterval: "LblPaymentInterval",
  LblInvoicInterval: "LblInvoicInterval",
  LblInterval: "LblInterval",
  LblInvoiceMomentDay: "LblInvoiceMomentDay",
  LblInvoiceMomentMonth: "LblInvoiceMomentMonth",
  LblFreeMinuteInterval: "LblFreeMinuteInterval",
  LblFreeKMInterval: "LblFreeKMInterval",
  LblSelectSubscriptionInterval: "LblSelectSubscriptionInterval",
  LblSelectInvoiceInterval: "LblSelectInvoiceInterval",
  LblSelectPaymentInterval: "LblSelectPaymentInterval",
  LblSelectFreeKMInterval: "LblSelectFreeKMInterval",
  LblSelectFreeMinInterval: "LblSelectFreeMinInterval",
  LblYearlySub: "LblYearlySub",
  LblMonthlySub: "LblMonthlySub",
  LblWeeklySub: "LblWeeklySub",
  LblFreePerWeek: "LblFreePerWeek",
  LblFreePerMonth: "LblFreePerMonth",
  LblFreePerTriMonth: "LblFreePerTriMonth",
  LblFreePerBiannual: "LblFreePerBiannual",
  LblFreePerYear: "LblFreePerYear",
  LblDefaultContractTypeGroup: "LblDefaultContractTypeGroup",
  LblSelectDefaultContractTypeGroup: "LblSelectDefaultContractTypeGroup",
  LblSendInvoiceToDriver: "LblSendInvoiceToDriver",
  LblInherit: "LblInherit",

  //Invoice Moment
  LblDayOfMonth: "LblDayOfMonth",
  LblDayOfWeek: "LblDayOfWeek",
  LblSelectDayOfWeek: "LblSelectDayOfWeek",
  LblInstanceLogo: "LblInstanceLogo",
  LblInvoiceDeleteValidation:
    "LblInvoiceDeleteValidation",

  //SubscriptionAvailabilityRestriction
  LblSubscriptionAvailabilityRestriction:
    "LblSubscriptionAvailabilityRestriction",
  LblStartDay: "LblStartDay",
  LblEndDay: "LblEndDay",
  LblStartTime: "LblStartTime",
  LblEndTime: "LblEndTime",
  LblRestriction: "LblRestriction",
  LblTotalFreeKilometer: "LblTotalFreeKilometer",
  LblTotalFreeMinute: "LblTotalFreeMinute",
  LblCurRemainFreeKilometer: "LblCurRemainFreeKilometer",
  LblPrevRemainFreeKilometer: "LblPrevRemainFreeKilometer",
  LblCurRemainFreeMinute: "LblCurRemainFreeMinute",
  LblPrevRemainFreeMinute: "LblPrevRemainFreeMinute",
  LblResetPasswordFailure: "LblResetPasswordFailure",

  //Additional Free Item
  LblAdditionalFreeItems: "LblAdditionalFreeItems",
  LblDateAwared: "LblDateAwared",
  LblAdditionalFreeItemsMenu: "LblAdditionalFreeItemsMenu",

  LblPrevious: "LblPrevious",
  LblCurrent: "LblCurrent",

  LblTripDetailReport: "LblTripDetailReport",
  LblTripDetailList: "LblTripDetailList",
  LblSearchTripforDriver: "LblSearchTripforDriver",
  LblExportReport: "LblExportReport",
  LblValidateLiceanceNumberMessage: "LblValidateLiceanceNumberMessage",
  LblBookingIntervalRate: "LblBookingIntervalRate",
  LblPerHour: "LblPerHour",
  LblPerBookingIntarval: "LblPerBookingIntarval",
  LblTimeRate: "LblTimeRate",
  LblToalBookingDuration: "LblToalBookingDuration",

  LblTripComments: "LblTripComment",
  LblTripCommentDescription: "LblTripCommentDescription",
  LblTripCommentError: "LblTripCommentError",
  LblShowTripComment: "LblShowTripComment",
  LblAddTripComment: "LblAddTripComment",
  LblTripCommentBy:"LblTripCommentBy",
  LblTripCommentOn: "LblTripCommentOn",  

  LblCleanRequire: "LblCleanRequire",
  LblFualRequire: "LblFualRequire",
  LblVehicleDamageList: "LblVehicleDamageList",
  LblDamageCause: "LblDamageCause",
  LblDamageReportedBy: "LblDamageReportedBy",
  LblDamageReportedOn: "LblDamageReportedOn",
  LblConfirmResolveDamage: "LblConfirmResolveDamage",
  LblVehicleDamgeResolveSuccess: "LblVehicleDamgeResolveSuccess",
  LblDamageDesc: "LblDamageDesc",
  LblFutureBooking: "LblFutuLblVehFutureBookingList",
  LblResolveDamge: "LblResolveDamge",
  LblReserved: "LblReserved",
  LblVehicleInfoSuccess: "LblVehicleInfoSuccess",
  LblInformation: "LblInformation",
  LblVTSHistory: "LblVTSHistory",
  LblWegoRequestTime: "LblWegoRequestTime",
  LblVTSRequestTime: "LblVTSRequestTime",
  LblRequestType: "LblRequestType",
  LblWegoProcessTime: "LblWegoProcessTime",
  LblResult: "LblResult",
  LblWegoResultTime: "LblWegoResultTime",
  LblVTSResultTime: "LblVTSResultTime",
  LblCommandInitiator: "LblCommandInitiator",

  LblTroubleShootVTS: "LblTroubleShootVTS",
  LblVtsServiceStatus: "LblVtsServiceStatus",
  LblVtsLicencetag: "LblVtsLicencetag",
  LblVtsDoorStatus: "LblVtsDoorStatus",
  LblVtsIssueCommand: "LblVtsIssueCommand",
  LblVehicleLocation: "LblVehicleLocation",
  LblEventHistory: "LblEventHistory",
  LblView: "LblView",
  LblVehicleObuStatus: "LblVehicleObuStatus",
  LblVehicleNotInitialized: "LblVehicleNotInitialized",
  LblLastReceivedTime: "LblLastReceivedTime",

  LblFreePerBookingInterval: "LblFreePerBookingInterval",

  LblSelectFilter: "LblSelectFilter",
  LblAuditEntries: "LblAuditEntries",
  LblFilter: "LblFilter",
  LblCategory: "LblCategory",
  LblEventName: "LblEventName",
  LblEventData: "LblEventData",
  LblMoment: "LblMoment",
  LblUser: "LblUser",
  LblNoEventDataFound: "LblNoEventDataFound",
  LblEventViewer: "LblEventViewer",

  LblSelectObuType: "LblSelectObuType",

  LblObuType: "LblObuType",
  LblDeviceId: "LblDeviceId",
  LblClaimCode: "Claim code",

  LblVtsLocation: "LblVtsLocation",
  LblRetriveAddress: "LblRetriveAddress",
  LblCrearedDate: "LblCrearedDate",
  LblCreatedBy: "LblCreatedBy",
  LblPerBooking: "LblPerBooking",
  LblOBU: "LblOBU",
  LblClone: "LblClone",
  LblCloneVehicle: "LblCloneVehicle",
  LblFualNotRequire: "LblFualNotRequire",
  LblCleanNotRequire: "LblCleanNotRequire",
  LblSubscriptionInfo: "LblSubscriptionInfo",
  LblVehiclDamaged: "LblVehiclDamaged",
  LblVehicleNotDamaged: "LblVehicleNotDamaged",
  LblDamage: "LblDamage",
  LblFreeBooking: "LblFreeBooking",
  LblBookingCustomFee: "LblBookingCustomFee",
  LblFreeBookingSuccess: "LblFreeBookingSuccess",
  LblEnterLocation: "LblEnterLocation",
  LblHomeLocation: "LblHomeLocation",
  LblLocationMode: "LblLocationMode",
  LblMeter: "LblMeter",
  LblLocation: "LblLocation",
  LblPickupLocation: "LblPickupLocation",
  LblLocationUnavailable: "LblLocationUnavailable",
  LblAvailabilityCalander: "LblAvailabilityCalander",
  LblAvailableOn: "LblAvailableOn",
  LblGeofenceEnabled: "LblGeofenceEnabled",
  LblLocationNotFound: "LblLocationNotFound",
  LblAddressNotAvailable: "LblAddressNotAvailable",
  LblReports: "LblReports",
  LblDrivers: "LblDrivers",
  LblTemplates: "LblTemplates",
  LblVehicleOccupancyReport: "LblVehicleOccupancyReport",
  LblPlaceHolder: "LblPlaceHolder",
  LblSampleTemplate: "LblSampleTemplate",
  LblLatexFileDownloadValidation: "LblLatexFileDownloadValidation",
  LblLocationDataExchangeNotAssign: "LblLocationDataExchangeNotAssign",
  LblReservedTime: "LblReservedTime",
  LblUsageTime: "LblUsageTime",
  LblUsageTimeAtOffice: "LblUsageTimeAtOffice",
  LblUsageTimeoutOffice: "LblUsageTimeoutOffice",
  LblRevenue: "LblRevenue",
  LblRevenuePerVehicleReport: "LblRevenuePerVehicleReport",
  LblSearchRevenuePerVehicle: "LblSearchRevenuePerVehicle",
  LblRevenuePerVehicleList: "LblRevenuePerVehicleList",

  //Dashboard
  LblInuse: "LblInuse",
  LblPriority: "LblPriority",
  LblDefaultStatus: "LblDefaultStatus",

  //OdometerLogTrail
  LblOdometerLogTrail: "LblOdometerLogTrail",
  LblUserProvidedOdometerValueInKmr: "LblUserProvidedOdometerValueInKmr",
  LblDescriptionOfDeviation: "LblDescriptionOfDeviation",
  LblFromOdometer: "LblFromOdometer",
  LblToOdometer: "LblToOdometer",
  LblAddDescriptionOfDeviation: "LblAddDescriptionOfDeviation",
  LblDeviation: "LblDeviation",
  LblLastOdometerValue: "LblLastOdometerValue",
  LblLastOdometerDT: "LblLastOdometerDT",

  LblOdometerRegistered: "LblOdometerRegistered",
  LblOdometerValue: "LblOdometerValue",
  LblMaintenancePlanningList: "LblMaintenancePlanningList",
  LblSearchMaintenancePlanningValue: "LblSearchMaintenancePlanningValue",
  LblMaintenancePlanningreport: "LblMaintenancePlanningreport",

  LblodometerConfiguration: "LblodometerConfiguration",
  LbLOdometerEnabled: "LbLOdometerEnabled",
  LblEnableOnApp: "LblEnableOnApp",
  LblWarningPer: "LblWarningPer",
  LblShowDeviation: "LblShowDeviation",

  LblTitle: "LblTitle",
  LblFooterText: "LblFooterText",
  LblvalidEmailDomain: "LblvalidEmailDomain",
  LblURLSettings: "LblURLSettings",
  LblSuccessUrl: "LblSuccessUrl",
  LblEmailSettings: "LblEmailSettings",
  LblSendActivationEmail: "LblSendActivationEmail",
  LblSendConfirmationEmail: "LblSendConfirmationEmail",
  LblRequireAdminApprovel: "LblRequireAdminApprovel",
  LblDriverInformationToBeInclude: "LblDriverInformationToBeInclude",
  LblSignUpForm: "LblSignUpForm",
  LblSignupForms: "LblSignupForms",
  LblSignupFormsOverview: "LblSignupFormsOverview",
  LblWhoCanApprove: "LblWhoCanApprove",
  LblSignupFormLogo: "LblSignupFormLogo",
  LblChooseSubscription: "LblChooseSubscription",
  LblSignupParameter: "LblSignupParameter",
  LblSignupParameterText: "LblSignupParameterText",
  DomainNameString: "DomainNameString",
  SignupParameterString: "SignupParameterString",

  LblAvailability: "LblAvailability",
  LblSettings: "LblSettings",
  LblCurrentStatus: "LblCurrentStatus",
  LblFlags: "LblFlags",
  LblNA: "LblNA",

  //Sign up form
  LblConfirmEmail: "LblConfirmEmail",
  LblSignup: "LblSignup",

  LblSignupsOverView: "LblSignupsOverView",
  LblSignupApproval: "LblSignupApproval",
  LblAccept: "LblAccept",
  LblSignupFormDescription: "LblSignupFormDescription",

  LblCurrentOdometerValue: "LblCurrentOdometerValue",
  LblCurrentOdometerDateTime: "LblCurrentOdometerDateTime",

  LblCreateDirectDebitFile: "LblCreateDirectDebitFile",
  LblCheckEmptyIbanNumber: "LblCheckEmptyIbanNumber",
  LblCreatedDate: "LblCreatedDate",
  LblIncludeInDirectDebit: "LblIncludeInDirectDebit",
  LblDirectDebitFileDate: "LblDirectDebitFileDate",
  LblDirectDebitConfiguration: "LblDirectDebitConfiguration",
  LbLDirectDebitEnabled: "LbLDirectDebitEnabled",
  LblDirectDebitEnableper: "LblDirectDebitEnableper",
  LbLCreditorDetails: "LbLCreditorDetails",
  LblAddress: "LblAddress",
  LblIBANNumber: "LblIBANNumber",
  LblCountryCode: "LblCountryCode",
  LbLBillingInformation: "LbLBillingInformation",
  LblFormat: "LblFormat",
  LblInvoicingDetails: "LblInvoicingDetails",
  LbLSubjectToDirectDebit: "LbLSubjectToDirectDebit",

  //Person Upload Batch
  LblBatchUploadPersonSetting: "LblBatchUploadPersonSetting",
  LblShowBatchUploadInfo: "LblShowBatchUploadInfo",
  LblAllowBatchUpload: "LblAllowBatchUpload",
  LblAllowActivationMail: "LblAllowActivationMail",
  LblGenerateRandomPassword: "LblGenerateRandomPassword",
  LblUserUploadPassword: "LblUserUploadPassword",
  LblFieldToUploadedOrValidated: "LblFieldToUploadedOrValidated",
  LblBatchUploadPerson: "LblBatchUploadPerson",
  LblBatchUpload: "LblBatchUpload",
  LblImportDriverRole: "LblImportDriverRole",
  LblAssignToSVG: "LblAssignToSVG",
  LblSVG: "LblSVG",
  LblDownloadTemplate: "LblDownloadTemplate",
  LblUserAssignSVGMessage: "LblUserAssignSVGMessage",
  LblInvalidRecordReason: "LblInvalidRecordReason",
  LblSelectedSVGs: "LblSelectedSVGs",

  LblDashboard: "LblDashboard",
  LblGroupAdmin: "LblGroupAdmin",
  LblDashboardConfiguration: "LblDashboardConfiguration",
  LblCurrentLocation: "LblCurrentLocation",
  LblEnableCurrentLocation: "LblEnableCurrentLocation",
  LblDefaultLocation: "LblDefaultLocation",
  LblEnableAutoUpdate: "LblEnableAutoUpdate",
  LblPriorityNotificationSetting: "LblPriorityNotificationSetting",
  LblCollectionDate: "LblCollectionDate",
  LblBICCode: "LblBICCode",
  LblDirectDebitFile: "LblDirectDebitFile",
  LblMissingIBANNumber: "LblMissingIBANNumber",

  LblCurrentDriver: "LblCurrentDriver",
  LblNextDriver: "LblNextDriver",
  LblSecond: "LblSecond",

  LblCleaning: "LblCleaning",
  LblRefueling: "LblRefueling",
  LblAPKMaintenance: "LblAPKMaintenance",
  LblOutsideGeofence: "LblOutsideGeofence",
  LblNotBooked: "LblNotBooked",
  LblNotBookedSince: "LblNotBookedSince",
  LblLowBattery: "LblLowBattery",
  LblBatteryVolt: "LblBatteryVolt",
  LblLowCharge: "LblLowCharge",
  LblChargingPercentage: "LblChargingPercentage",
  LblOnSamePosition: "LblOnSamePosition",
  LblLastPosition: "LblLastPosition",
  LblNotReturn: "LblNotReturn",
  LblCommunicationProblem: "LblCommunicationProblem",
  LblDirectDebitDownloadSuccess: "LblDirectDebitDownloadSuccess",
  LblWarnings: "LblWarnings",
  LblDirectDebitFileId: "LblDirectDebitFileId",
  LblTotalAmount: "LblTotalAmount",
  LblReCreate: "LblReCreate",
  LblPleaseEnterCollectionDate: "LblPleaseEnterCollectionDate",
  LblOpenViaLowLevel: "LblOpenViaLowLevel",
  LblInstanceNotificationNote1: "LblInstanceNotificationNote1",
  LblNoInvoiceSelected: "LblNoInvoiceSelected",
  LblIBANNumberRequired: "LblIBANNumberRequired",
  LblNoEmptyIBANFound: "LblNoEmptyIBANFound",
  LblInvalidTagUsed: "LblInvalidTagUsed",
  LblNotInvalidTagUsed: "LblNotInvalidTagUsed",

  LblShowVehicleChargeLevel: "LblShowVehicleChargeLevel",
  LblChargeLevel: "LblChargeLevel",
  LblCharging: "Charging",
  LblNoDataFound: "LblNoDataFound",
  LblOfficeStartTime: "LblOfficeStartTime",
  LblOfficeEndTime: "LblOfficeEndTime",
  //Reports
  LblTripDataReport: "LblTripDataReport",
  LblByDriver: "LblByDriver",
  LblByVehicle: "LblByVehicle",
  LblByOrganization: "LblOrgnization",
  LblModuleRights: "LblModuleRights",
  //Organization
  LblOrganization: "LblOrganization",
  LblOrganizationName: "LblOrganizationName",
  LblOrganizationAddress: "LblOrganizationAddress",
  LblAddDriverSuccessMsg: "LblAddDriverSuccessMsg",
  LblExistingDriverAddSuccessMsg: "LblExistingDriverAddSuccessMsg",
  LblAddDriver: "LblAddDriver",
  LblCreateOrganization: "LblCreateOrganization",
  LblAddDriverToOrganization: "Add Driver To Organization",
  LblOrganizationDriversList: "LblOrganizationDriversList",
  LblVatNumber: "LblVatNumber",
  // Branding
  LblBranding: "LblBranding",
  LblLogo: "LblLogo",
  LblEmailNotificationInvoiceTemplate: "LblEmailNotificationInvoiceTemplate",
  LblExpandedWebMenu: "LblExpandedWebMenu",
  LblCollapsedWebMenu: "LblCollapsedWebMenu",
  LblMobileApp: "LblMobileApp",
  LblSplashScreen: "LblSplashScreen",
  LblWebApplication: "LblWebApplication",
  LblMobileApplication: "LblMobileApplication",
  LblBrandingSavedSuccess: "LblBrandingSavedSuccess",
  LblBrandingTemplateConfiguration: "LblBrandingTemplateConfiguration",
  LblAppWebUI: "LblAppWebUI",
  LblNonBookingCommunication: "LblNonBookingCommunication",
  LblBookingCommunication: "LblBookingCommunication",
  LblInstanceBranding: "LblInstanceBranding",
  LblCompanyBranding: "LblCompanyBranding",
  BO_TOP_MENU_ACTIVE_ITEM_BACKGROUND: "BO_TOP_MENU_ACTIVE_ITEM_BACKGROUND",
  BO_TOP_MENU_ACTIVE_ITEM_TEXT: "BO_TOP_MENU_ACTIVE_ITEM_TEXT",
  BO_HIGHLIGHTED_BUTTON_BACKGROUND: "BO_HIGHLIGHTED_BUTTON_BACKGROUND",
  BO_HIGHLIGHTED_BUTTON_TEXT: "BO_HIGHLIGHTED_BUTTON_TEXT",
  BO_HIGHLIGHTED_BUTTON_BACKGROUND_HOVER:
    "BO_HIGHLIGHTED_BUTTON_BACKGROUND_HOVER",
  BO_HIGHLIGHTED_BUTTON_TEXT_HOVER: "BO_HIGHLIGHTED_BUTTON_TEXT_HOVER",
  BO_PRIMARY_BUTTON_BACKGROUND: "BO_PRIMARY_BUTTON_BACKGROUND",
  BO_PRIMARY_BUTTON_TEXT: "BO_PRIMARY_BUTTON_TEXT",
  BO_PRIMARY_BUTTON_BACKGROUND_HOVER: "BO_PRIMARY_BUTTON_BACKGROUND_HOVER",
  BO_PRIMARY_BUTTON_TEXT_HOVER: "BO_PRIMARY_BUTTON_TEXT_HOVER",
  BO_SECONDARY_BUTTON_BACKGROUND: "BO_SECONDARY_BUTTON_BACKGROUND",
  BO_SECONDARY_BUTTON_TEXT: "BO_SECONDARY_BUTTON_TEXT",
  BO_SECONDARY_BUTTON_BACKGROUND_HOVER: "BO_SECONDARY_BUTTON_BACKGROUND_HOVER",
  BO_SECONDARY_BUTTON_TEXT_HOVER: "BO_SECONDARY_BUTTON_TEXT_HOVER",
  BO_HYPERLINK_TEXT: "BO_HYPERLINK_TEXT",
  BO_HIGHLIGHT_BACKGROUND: "BO_HIGHLIGHT_BACKGROUND",
  BO_HIGHLIGHT_TEXT: "BO_HIGHLIGHT_TEXT",
  BO_CALENDAR_EVENT_BACKGROUND: "BO_CALENDAR_EVENT_BACKGROUND",
  BO_CALENDAR_EVENT_TEXT: "BO_CALENDAR_EVENT_TEXT",
  MO_TOP_MENU_ACTIVE_ITEM_BACKGROUND: "MO_TOP_MENU_ACTIVE_ITEM_BACKGROUND",
  MO_LOGO_AREA_BACKGROUND: "MO_LOGO_AREA_BACKGROUND",
  MO_PAGE_BACKGROUND: "MO_PAGE_BACKGROUND",
  MO_MENU_TEXT: "MO_MENU_TEXT",
  MO_TITLE_TEXT: "MO_TITLE_TEXT",
  MO_HYPERLINK_TEXT: "MO_HYPERLINK_TEXT",
  MO_ENABLED_BUTTON_BACKGROUND: "MO_ENABLED_BUTTON_BACKGROUND",
  MO_ENABLED_BUTTON_TEXT: "MO_ENABLED_BUTTON_TEXT",
  MO_ENABLED_BUTTON_BACKGROUND_ACTIVE: "MO_ENABLED_BUTTON_BACKGROUND_ACTIVE",
  MO_ENABLED_BUTTON_TEXT_ACTIVE: "MO_ENABLED_BUTTON_TEXT_ACTIVE",
  MO_DISABLED_BUTTON_BACKGROUND: "MO_DISABLED_BUTTON_BACKGROUND",
  MO_DISABLED_BUTTON_TEXT: "MO_DISABLED_BUTTON_TEXT",
  MO_DISABLED_BUTTON_BACKGROUND_ACTIVE: "MO_DISABLED_BUTTON_BACKGROUND_ACTIVE",
  MO_DISABLED_BUTTON_TEXT_ACTIVE: "MO_DISABLED_BUTTON_TEXT_ACTIVE",
  MO_HIGHLIGHT_BACKGROUND: "MO_HIGHLIGHT_BACKGROUND",
  MO_HIGHLIGHT_TEXT: "MO_HIGHLIGHT_TEXT",
  MO_CALENDAR_EVENT_BACKGROUND: "MO_CALENDAR_EVENT_BACKGROUND",
  MO_CALENDAR_EVENT_TEXT: "MO_CALENDAR_EVENT_TEXT",
  LblBookingDelayConfig: "LblBookingDelayConfig",
  LblBookingDelayConfigEnabled: "LblBookingDelayConfigEnabled",
  LblEnableSnauilTrail: "LblEnableSnauilTrail",
  LblAppSupportTo: "LblAppSupportTo",
  LblNotificationInterval: "LblNotificationInterval",
  LblNotifyAfterMinutes: "LblNotifyAfterMinutes",
  LblMinutesAfterBookingEndTime: "LblMinutesAfterBookingEndTime",
  LblResendNotoficationEvery: "LblResendNotoficationEvery",
  LblMinutes: "LblMinutes",
  lblNotificationRecipients: "lblNotificationRecipients",
  LbLEnableBookingStillRunning: "LbLEnableBookingStillRunning",
  LblBookingrunningNotification: "LblBookingrunningNotification",
  LblPreferableImageSize: "LblPreferableImageSize",
  LblWebBrandingExapandImageSize: "LblWebBrandingExapandImageSize",
  LblMobileBrandingImageSize: "LblMobileBrandingImageSize",
  LblWebBrandingCollapseImageSize: "LblWebBrandingCollapseImageSize",

  //Raise and clear settings for low battery flag
  LblDefaultVehicleSetting: "LblDefaultVehicleSetting",
  LblLowBatteryFlagRaised: "LblLowBatteryFlagRaised",
  LblLowBatteryFlagClear: "LblLowBatteryFlagClear",
  LblByBooking: "LblByBooking",
  LblSnailTrailReport: "LblSnailTrailReport",
  LblKickbackReport: "LblKickbackReport",
  LblGroupBy: "LblGroupBy",
  LblTripDetail: "LblTripDetail",
  LblTripNumber: "LblTripNumber",
  LblStart: "LblStart",
  LblAverageSpeed: "LblAverageSpeed",
  LblSegmentDetail: "LblSegmentDetail",
  LblSegmentNumber: "LblSegmentNumber",
  LblSpeed: "LblSpeed",
  LblOdometer: "LblOdometer",
  LblNext: "LblNext",
  LblSegmentDetailNotAvailable: "LblSegmentDetailNotAvailable",
  LblUnitPerKm: "LblUnitPerKm",
  LblUnitPerBooking: "LblUnitPerBooking",

  LblBookingCostSummary: "LblBookingCostSummary",
  LblTimeCost: "LblTimeCost",
  LblTotalTime: "LblTotalTime",
  LblTime: "LblTime",
  LblFreeTime: "LblFreeTime",
  LblRate: "LblRate",
  LblExVat: "LblExVat",
  LblInclVat: "LblInclVat",
  LblKmDriven: "LblKmDriven",
  LblFreeKms: "LblFreeKms",
  LblTimePercent: "LblTimePercent",
  LblTotalExVat: "LblTotalExVat",
  LblTotalVat: "LblTotalVat",
  LblTotalInclVat: "LblTotalInclVat",
  LblKilometerCost: "LblKilometerCost",
  LblFixedCost: "LblFixedCost",
  LblTotals: "LblTotals",
  LblTypeDamage: "LblTypeDamage",
  LblTypeMaintenance: "LblTypeMaintenance",
  LblTypeOnSamePosition: "LblTypeOnSamePosition",
  LblTypeNotBooked: "LblTypeNotBooked",
  LblTypeNotReturn: "LblTypeNotReturn",
  LblBatteryVoltage: "LblBatteryVoltage",

  LblCannotUnsubscribe: "LblCannotUnsubscribe",
  LblPer: "LblPer",

  LblDateRegistered: "LblDateRegistered",
  LblRegisteredBy: "LblRegisteredBy",
  LblKMPerHour: "LblKMPerHour",
  LblMeters: "LblMeters",
  LblSubscriptionEndOnBookingEnd: "LblSubscriptionEndOnBookingEnd",
  LblMarkedForDeletion: "LblMarkedForDeletion",
  LblApplyDateFilter: "LblApplyDateFilter",

  LblNoRestriction: "LblNoRestriction",
  LblCustomAppTestApp: "LblCustomAppTestApp",
  LblCustomAppOnly: "LblCustomAppOnly",

  //Customer
  LblCustomer: "LblCustomer",
  LblCustomerName: "LblCustomerName",

  //Role Page
  LblRoleManagement: "LblRoleManagement",
  LblRoleName: "LblRoleName",
  LblEntityName: "LblEntityName",
  LblRoleType: "LblRoleType",

  LblVehFutureBookingList: "LblVehFutureBookingList",
  LblRoleAvailability: "LblRoleAvailability",
  LblInternalRoleName: "LblInternalRoleName",
  LblPresentationName: "LblPresentationName",
  LblDefaultRole: "LblDefaultRole",
  LblCustomRole: "LblCustomRole",
  LblAddRole: "LblAddRole",
  LblEntity: "LblEntity",
  LblCopy: "LblCopy",
  LblAccessibilityMatrix: "LblAccessibilityMatrix",
  LblDefaultRoleModifyWarning: "LblDefaultRoleModifyWarning",
  LblCopyAccessibilityMatrix: "LblCopyAccessibilityMatrix",
  LblAccess: "LblAccess",

  LblCustomerAdmin: "LblCustomerAdmin",
  LblAdmin: "LblAdmin",
  LblDoYouWantToRemove: "LblDoYouWantToRemove",
  LblDoYouWantToAdd: "LblDoYouWantToAdd",
  LblRoleAddedSuccess: "LblRoleAddedSuccess",
  LblRoleDeletedSuccess: "LblRoleDeletedSuccess",
  LblInstanceAdmin: "LblInstanceAdmin",
  LblInvitationMailSuccess: "LblInvitationMailSuccess",
  LblInvite: "LblInvite",
  LblCreateNew: "LblCreateNew",
  LblCommonErrorMessage: "LblCommonErrorMessage",
  LblError: "LblError",
  LblThankYouForAcceptingInvitation: "LblThankYouForAcceptingInvitation",
  LblPleaseClick: "LblPleaseClick",
  LblHere: "LblHere",
  LblToLogin: "LblToLogin",
  LblThankYouForConfirmation: "LblThankYouForConfirmation",
  LblGoToHome: "LblGoToHome",
  LblInvitationSuccess: "LblInvitationSuccess",
  LblInvitationReject: "LblInvitationReject",

  //
  LblAssignExisting: "LblAssignExisting",
  LblPersonProfileSuccessMessage: "LblPersonProfileSuccessMessage",
  LblPlease: "LblPlease",
  LblLogin: "LblLogin",

  //Branding & Template
  LblBrandingandTemplates: "LblBrandingandTemplates",
  LblTermsAndCondition: "LblTermsAndCondition",
  LblTermsAndConditionList: "LblTermsAndCondition",
  LblName: "LblName",
  LblVersion: "LblVersion",
  LblAcceptance1: "LblAcceptance1",
  LblAcceptanceMoment: "LblAcceptanceMoment",
  LblContents: "LblContents",
  LblIsAccept: "LblIsAccept",
  LblReadAndAgree: "LblReadAndAgree",
  LblClose: "LblClose",
  LblTermsConditionPrivacy: "LblTermsConditionPrivacy",
  LblPrivacyStatements: "LblPrivacyStatements",
  //Pre Post Trip Setting
  LblPrePostTripSetting: "LblPrePostTripSetting",

  LblPrePostTripQuestion: "LblPrePostTripQuestion",
  LblPrePostTripQuestionList: "LblPrePostTripQuestionList",
  LblPreTripQuestion: "LblPreTripQuestion",
  LblCustom: "LblCustom",
  LblPostTripQuestion: "LblPostTripQuestion",
  LblRequired: "LblRequired",
  LblBeforeOpeningTheVehicle: "LblBeforeOpeningTheVehicle",
  LblAfterOpeningTheVehicle: "LblAfterOpeningTheVehicle",
  LblOrder: "LblOrder",
  LblQuestion: "LblQuestion",
  LblOptional: "LblOptional",
  LblAnswerType: "LblAnswerType",
  LblText: "LblText",
  LblYesNo: "LblYesNo",
  LblAnswer: "LblAnswer",
  LblTimeStamp: "LblTimeStamp",
  LblFazTripQuestion: "LblFazTripQuestion",
  LblFazTripQuestionAfterClosingTheVehicle: "LblFazTripQuestionAfterClosingTheVehicle",

  //Accessibility Matrix
  LG_WEB_DASHBOARD: "LG_WEB_DASHBOARD",
  PR_DASHBOARD: "PR_DASHBOARD",
  PR_REMOVE_DRIVER_LICENSE: "Remove Driver License",
  PR_VEHICLE_FUTURE_BOOKINGS: "PR_VEHICLE_FUTURE_BOOKINGS",
  PR_INSTANCE: "PR_INSTANCE",
  PR_BRANDING: "PR_BRANDING",
  PR_PERSON_OVERVIEW: "PR_PERSON_OVERVIEW",
  PR_WEGO_ADMINS: "PR_WEGO_ADMINS",
  PR_COMPANY_OVERVIEW: "PR_COMPANY_OVERVIEW",
  PR_CONTACT_PERSON: "PR_CONTACT_PERSON",
  PR_COMPANY_ADMIN: "PR_COMPANY_ADMIN",
  PR_COMPANY_VEHICLE_OVERVIEW: "PR_COMPANY_VEHICLE_OVERVIEW",
  PR_COMPANY_SVG_OVERVIEW: "PR_COMPANY_SVG_OVERVIEW",
  PR_ORGANIZATION_OVERVIEW: "PR_ORGANIZATION_OVERVIEW",
  PR_ORGANIZATION_CONTACT_PERSON: "PR_ORGANIZATION_CONTACT_PERSON",
  PR_ORGANIZATION_ADMIN_OVERVIEW: "PR_ORGANIZATION_ADMIN_OVERVIEW",
  PR_ORGANIZATION_DRIVER_OVERVIEW: "PR_ORGANIZATION_DRIVER_OVERVIEW",
  PR_SHARED_VEHICLE_GROUP_OVERVIEW: "PR_SHARED_VEHICLE_GROUP_OVERVIEW",
  PR_SHARED_VEHICLE_GROUP_ADMIN_OVERVIEW:
    "PR_SHARED_VEHICLE_GROUP_ADMIN_OVERVIEW",
  PR_SHARED_VEHICLE_GROUP_VEHICLE_OVERVIEW:
    "PR_SHARED_VEHICLE_GROUP_VEHICLE_OVERVIEW",
  PR_SHARED_VEHICLE_GROUP_DRIVER_OVERVIEW:
    "PR_SHARED_VEHICLE_GROUP_DRIVER_OVERVIEW",
  PR_SHARED_VEHICLE_GROUP_CONTRACT_TYPE_GROUP_OVERVIEW:
    "PR_SHARED_VEHICLE_GROUP_CONTRACT_TYPE_GROUP_OVERVIEW",
  PR_SHARED_VEHICLE_GROUP_CONTRACT_TYPE_OVERVIEW:
    "PR_SHARED_VEHICLE_GROUP_CONTRACT_TYPE_OVERVIEW",
  PR_SHARED_VEHICLE_GROUP_SUBSCRIPTION_OVERVIEW:
    "PR_SHARED_VEHICLE_GROUP_SUBSCRIPTION_OVERVIEW",
  PR_SHARED_VEHICLE_GROUP_SUBSCRIPTION_AVAILIBILTY_RESTRICTION_OVERVIEW:
    "PR_SHARED_VEHICLE_GROUP_SUBSCRIPTION_AVAILIBILTY_RESTRICTION_OVERVIEW",
  PR_SPECIAL_PERIODS: "PR_SPECIAL_PERIODS",
  PR_VEHICLES_OVERVIEW: "PR_VEHICLES_OVERVIEW",
  PR_VEHICLE_SVG_OVERVIEW: "PR_VEHICLE_SVG_OVERVIEW",
  PR_VTS_VEHICLE_LIST: "PR_VTS_VEHICLE_LIST",
  PR_VTS_TROUBLESHOOT: "PR_VTS_TROUBLESHOOT",
  PR_VEHICLE_ATTRIBUTE_CATEGORIES: "PR_VEHICLE_ATTRIBUTE_CATEGORIES",
  PR_VEHICLE_ATTRIBUTE: "PR_VEHICLE_ATTRIBUTE",
  PR_ODOMETER_LOG_TRAIL: "PR_ODOMETER_LOG_TRAIL",
  PR_ODOMETER_LOG_TRAIL_REGISTERED_BY: "PR_ODOMETER_LOG_TRAIL_REGISTERED_BY",
  PR_DRIVER_OVERVIEW: "PR_DRIVER_OVERVIEW",
  PR_DRIVER_SHARED_VEHICLE_GROUP_OVERVIEW:
    "PR_DRIVER_SHARED_VEHICLE_GROUP_OVERVIEW",
  PR_DRIVER_SHARED_VEHICLE_GROUP_SUBSCRIPTION_OVERVIEW:
    "PR_DRIVER_SHARED_VEHICLE_GROUP_SUBSCRIPTION_OVERVIEW",
  PR_BOOKINGS_OVERVIEW: "PR_BOOKINGS_OVERVIEW",
  PR_NORMAL_BOOKING: "PR_NORMAL_BOOKING",
  PR_SPECIAL_BOOKING: "PR_SPECIAL_BOOKING",
  PR_TRIP_SIMULATOR: "PR_TRIP_SIMULATOR",
  PR_INVOICE: "PR_INVOICE",
  PR_DIRECT_DEBIT_FILE: "PR_DIRECT_DEBIT_FILE",
  PR_ADDITIONAL_FREE_ITEMS: "PR_ADDITIONAL_FREE_ITEMS",
  PR_TEST_INVOICE_GENERATOR: "PR_TEST_INVOICE_GENERATOR",
  PR_VEHICLE_OCCUPANCY_REPORT: "PR_VEHICLE_OCCUPANCY_REPORT",
  PR_REVENUE_PER_VEHICLE_REPORT: "PR_REVENUE_PER_VEHICLE_REPORT",
  PR_TRIP_DATA_REPORT: "PR_TRIP_DATA_REPORT",
  PR_MAINTENANCE_PLANNING_REPORT: "PR_MAINTENANCE_PLANNING_REPORT",
  PR_SANIL_TRAIL_REPORT: "PR_SANIL_TRAIL_REPORT",
  PR_KICKBACK_REPORT: "PR_KICKBACK_REPORT",
  PR_INVOICE_PAYMENT_HISTORY: "PR_INVOICE_PAYMENT_HISTORY",
  PR_TEMPLATES: "PR_TEMPLATES",
  PR_SIGNUP_FORMS_OVERVIEW: "PR_SIGNUP_FORMS_OVERVIEW",
  PR_SIGNUPS_OVERVIEW: "PR_SIGNUPS_OVERVIEW",
  PR_SIGNUP_OVERVIEW_TO_SIGNUP_FORM: "PR_SIGNUP_OVERVIEW_TO_SIGNUP_FORM",
  PR_SIGNUP_OVERVIEW_TO_SHARED_VEHICLE_GROUP:
    "PR_SIGNUP_OVERVIEW_TO_SHARED_VEHICLE_GROUP",
  PR_EVENT_VIEWER: "PR_EVENT_VIEWER",
  PR_PRE_POST_TRIP_SETTING: "PR_PRE_POST_TRIP_SETTING",
  PR_PREPOST_TRIP_QUESTIONS_UPDATE: "PR_PREPOST_TRIP_QUESTIONS_UPDATE",
  PR_USER_PROFILE: "PR_USER_PROFILE",
  LG_CUSTOMER: "LG_CUSTOMER",
  LG_INSTANCE: "LG_INSTANCE",
  LG_BRANDING: "LG_BRANDING",
  PR_TERMS_AND_CONDITION: "PR_TERMS_AND_CONDITION",
  LG_PERSON: "LG_PERSON",
  LG_COMPANY: "LG_COMPANY",
  LG_ORGANIZATION: "LG_ORGANIZATION",
  LG_SHARED_VEHICLE_GROUP: "LG_SHARED_VEHICLE_GROUP",
  LG_VEHICLE: "LG_VEHICLE",
  LG_DRIVER: "LG_DRIVER",
  LG_BOOKING: "LG_BOOKING",
  LG_INVOICE: "LG_INVOICE",
  LG_REPORT: "LG_REPORT",
  LG_TEMPLATE: "LG_TEMPLATE",
  LG_SIGNUP_FORM: "LG_SIGNUP_FORM",
  LG_EVENT_VIEWER: "LG_EVENT_VIEWER",
  LG_PRE_POST_TRIP_SETTING: "LG_PRE_POST_TRIP_SETTING",
  LG_USER: "LG_USER",
  LG_BRANDING_AND_TEMPLATE: "LG_BRANDING_AND_TEMPLATE",

  LG_ROLE: "LG_ROLE",
  LG_PREPOSTTRIPQUESTION: "LG_PREPOSTTRIPQUESTION",
  PR_CUSTOMER_ADMIN_OVERVIEW: "PR_CUSTOMER_ADMIN_OVERVIEW",
  PR_INSTANCE_ADMIN_OVERVIEW: "PR_INSTANCE_ADMIN_OVERVIEW",
  PR_ROLE_OVERVIEW: "PR_ROLE_OVERVIEW",
  PR_ROLE_ASSIGN: "PR_ROLE_ASSIGN",
  PR_SHARED_VEHICLE_GROUP_ACTIVE_INACTIVE:
    "PR_SHARED_VEHICLE_GROUP_ACTIVE_INACTIVE",
  PR_CUSTOMER_OVERVIEW: "PR_CUSTOMER_OVERVIEW",
  PR_ORGANIZATION_SUBSCRIPTION_OVERVIEW:
    "PR_ORGANIZATION_SUBSCRIPTION_OVERVIEW",
  PR_VTS_VEHICLE_EVENT_HISTORY: "PR_VTS_VEHICLE_EVENT_HISTORY",
  PR_BATCH_UPLOAD_PERSON: "PR_BATCH_UPLOAD_PERSON",
  PR_IMPORT_PERSON: "PR_IMPORT_PERSON",

  LG_REPORTINGTOOL: "Reporting Tool",
  PR_BOOKING_OVERVIEW: "Booking overview",
  PR_ROB_NOTIFICATIONS: "ROB overview",
  PR_MILEAGE_OVERVIEW: "Mileage overview",
  PR_USAGE_OVERVIEW: "Number of days not used",
  PR_POSITION_ON_MAP: "Position on the map",
  PR_VEHICLE_ON_LOCATION_MAP: "Vehicle on location",
  PR_TRIP_OVERVIEW: "Trip registration",
  PR_ALTERNATE_TRANSPORTATION: "Alternate transportation",
  PR_AVERAGE_OVERVIEW: "Averages overview",
  PR_PRE_POST_BOOKING_OVERVIEW: "Pre/post questions per booking overview",
  PR_HOME_LOCATIONS_OVERVIEW: "Vehicle and SVG home locations overview",

  LblPrivacyErrorMessage: "LblPrivacyErrorMessage",
  LblPrivacyNavigate: "LblPrivacyNavigate",
  LblPrivacyError: "LblPrivacyError",
  LblLinkExpired: "LblLinkExpired",
  LblLinkExpiredMessage: "LblLinkExpiredMessage",
  PR_PRE_POST_TRIP_QUESTION_UPDATE: "PR_PRE_POST_TRIP_QUESTION_UPDATE",
  //Vat Setting

  LblVatSettings: "LblVatSettings",
  LblVatPercentages: "LblVatPercentages",
  LblDefaultCost: "LblDefaultCost",
  LblExcludingVat: "LblExcludingVat",
  LblIncludingVat: "LblIncludingVat",
  LblVatEnterDescription: "LblVatEnterDescription",
  LblEnterVatPercentage: "LblEnterVatPercentage",
  LblVatPercentageError: "LblVatPercentageError",
  LblVatDescriptionError: "LblVatDescriptionError",
  LblStartDate: "LblStartDate",
  LblVatEndDate: "LblVatEndDate",
  LblVatDeleteConfirmation: "LblVatDeleteConfirmation",
  LblVatEndDateError: "LblVatEndDateError",
  LblVatEndDateNote: "LblVatEndDateNote",
  LblExpenseAmountVat: "LblExpenseAmountVat",
  LblDefaultVatContractTypeGroupCost: "LblDefaultVatContractTypeGroupCost",
  LblDefaultVatContractTypeCost: "LblDefaultVatContractTypeCost",
  LblDefaultVatSubscriptionCost: "LblDefaultVatSubscriptionCost",
  LblPenaltyCost: "LblPenaltyCost",
  LblTimeRates: "LblTimeRates",
  LblDistanceRates: "LblDistanceRates",
  LblFixedRates: "LblFixedRates",
  LblSubscriptionCost: "LblSubscriptionCost",
  LblVatStartDate: "LblVatStartDate",
  LblVatStartDateError: "LblVatStartDateError",
  //

  LblBearer: "LblBearer",
  LblWhoBenifitFreeItem: "LblWhoBenifitFreeItem",

  LblNoDistinction: "LblNoDistinction",
  LblPenaltyVat: "LblPenaltyVat",
  LblTimeRateVat: "LblTimeRateVat",
  LblMileageRateVat: "LblMileageRateVat",
  LblFixedFeeVat: "LblFixedFeeVat",
  LblSendInvoiceToOrganization: "LblSendInvoiceToOrganization",

  // template
  LblEmailTemplate: "LblEmailTemplate",
  LblWebTemplate: "LblWebTemplate",
  LblEmailAddressesEntryPattern: "LblEmailAddressesEntryPattern",
  LblNoRecipientWarning: "LblNoRecipientWarning",

  LblCostAndExpenses: "LblCostAndExpenses",
  LblSender: "LblSender",
  LblAddressee: "LblAddressee",
  LblAddLine: "LblAddLine",
  LblSaveInvoice: "LblSaveInvoice",
  LblVatAmount: "LblVatAmount",
  LblBookingId: "LblBookingId",
  LblReceiptOrSuppor: "LblReceiptOrSuppor",
  LblVATPercentage: "LblVATPercentage",
  LblChargeTo: "LblChargeTo",
  LblReimburseTo: "LblReimburseTo",
  LblReportedBy: "LblReportedBy",
  LblReportedAmount: "LblReportedAmount",
  LblApprovedAmount: "LblApprovedAmount",
  LblCostType: "LblCostType",
  LblRecipient: "LblRecipient",
  LblCostDetail: "LblCostDetail",
  LblCostCenterReport: "LblCostCenterReport",
  LblShowTotalOnly: "LblShowTotalOnly",
  LblChamberOfCommerce: "LblChamberOfCommerce",
  LblInvoicingSettings: "LblInvoicingSettings",
  LblInvoiceSender: "LblInvoiceSender",

  LblAddExisting: "LblAddExisting",
  LblReceiptOrSupport: "LblReceiptOrSupport",
  LblManualInvoiceLine: "LblManualInvoiceLine",
  LblInvoiceLine: "LblInvoiceLine",
  LblInvoice: "LblInvoice",
  LblInvoiceLines: "LblInvoiceLines",
  LblSendInvoice: "LblSendInvoice",
  LblInvoiceSent: "LblInvoiceSent",
  LblAddNewInvoiceLine: "LblAddNewInvoiceLine",
  LblSelectUnprocessedExpenses: "LblSelectUnprocessedExpenses",
  LblSelectAtLeastOneExpense: "LblSelectAtLeastOneExpense",
  LblInvoicePaymentHistory: "LblInvoicePaymentHistory",
  LblPaymentMode: "LblPaymentMode",
  LblLogTime: "LblLogTime",

  LblNoPaymentLinkGenerated: "LblNoPaymentLinkGenerated",
  //Payment Module
  LblAllowPaymentConfiguration: "LblAllowPaymentConfiguration",
  LblAllowPayment: "LblAllowPayment",
  LblPaymentSetting: "LblPaymentSetting",
  LblEnvironment: "LblEnvironment",
  LblInvoicePaymentTermDays: "LblInvoicePaymentTermDays",
  LblLinkValidityDays: "LblLinkValidityDays",
  LblPaymentMethods: "LblPaymentMethods",
  LblPaymentProviderSecretKey: "LblPaymentProviderSecretKey",
  LblPaymentProviderUsername: "LblPaymentProviderUsername",
  LblCreditCardPayment: "LblCreditCardPayment",
  LblInitialPayment: "LblInitialPayment",
  LblCreateBookingPayment: "LblCreateBookingPayment",
  LblStartBookingPayment: "LblStartBookingPayment",
  LblPaymentLink: "LblPaymentLink",
  LblPaymentHistory: "LblPaymentHistory",
  LblReasonOrganization: "LblReasonOrganization",
  LblDueDateUpdateSuccess: "LblDueDateUpdateSuccess",
  LblDueDateRequiredError: "LblDueDateRequiredError",
  LblDueDate: "LblDueDate",
  LblConfirmDuedatechange: "LblConfirmDuedatechange",
  LblConfirmCloseInvoice: "LblConfirmCloseInvoice",
  LblConfirmReOpenInvoice: "LblConfirmReOpenInvoice",
  LblInvoiceOpenCloseSuccess: "LblInvoiceOpenCloseSuccess",
  LblReOpen: "LblReOpen",
  LblClosed: "LblClosed",
  LblReOpenClose: "LblReOpenClose",
  PR_COST_EXPENSES: "PR_COST_EXPENSES",
  PR_COST_CENTER_REPORT: "PR_COST_CENTER_REPORT",
  LblInactiveAfterDays: "LblInactiveAfterDays",
  LblMarkDeleteAfterDays: "LblMarkDeleteAfterDays",
  LblNotifyAdminBeforeDays: "LblNotifyAdminBeforeDays",
  LblGdprSettings: "LblGdprSettings",
  LblRemovalDate: "LblRemovalDate",
  LblRemovePersonOn: "LblRemovePersonOn",
  PR_PAYMENT_HISTORY_LIST: "PR_PAYMENT_HISTORY_LIST",
  LblUserBlockMessage: "LblUserBlockMessage",
  PR_BLOCK_UNBLOCK_ORGANIZATION: "PR_BLOCK_UNBLOCK_ORGANIZATION",
  LblWhenOpeningAppAndRepeat: "LblWhenOpeningAppAndRepeat",
  LblEveryTimeOpenApp: "LblEveryTimeOpenApp",
  LblWhenMakeBooking: "LblWhenMakeBooking",
  LblWhenStartBooking: "LblWhenStartBooking",
  LblWhenOpenBooking: "LblWhenOpenBooking",
  LblSelectContractTypeGroup: "LblSelectContractTypeGroup",
  LblDays: "LblDays",
  LblNewVersion: "LblNewVersion",
  LblAction: "LblAction",
  LblTAndCName: "LblTAndCName",
  LblOldVersion: "LblOldVersion",
  LblSureToRevoke: "LblSureToRevoke",
  LblReportedOn: "LblReportedOn",
  LblCurrencyConfiguration: "LblCurrencyConfiguration",
  LblNameSingular: "LblNameSingular",
  LblNamePlural: "LblNamePlural",

  //Special Period
  LblRegularBooking: "LblRegularBooking",
  LblSpecialRate: "LblSpecialRate",
  LblFirstDay: "LblFirstDay",
  LblLastDay: "LblLastDay",
  LblWeekEndContaining: "LblWeekEndContaining",
  LblSignBeforeAmount: "LblSignBeforeAmount",

  //Credit card payment
  LblCrediCardPayment: "LblCrediCardPayment",
  LblFirstBooking: "LblFirstBooking",
  LblAllowRecurringPayment: "LblAllowRecurringPayment",
  LblProceed: "LblProceed",
  LblCheckAllowPayment: "LblCheckAllowPayment",
  LblPaymentFailed: "LblPaymentFailed",
  LblPaymentSuccess: "LblPaymentSuccess",
  LblPaymentFailure: "LblPaymentFailure",
  LblCompletedSuccess: "LblCompletedSuccess",
  LblCompletedFailure: "LblCompletedFailure",
  LblCreditCardNumber: "LblCreditCardNumber",
  LblCreditCardExpirationDate: "LblCreditCardExpirationDate",
  LblCreditCardDetails: "LblCreditCardDetails",
  LblMakePayment: "LblMakePayment",
  LblAdminPaymentConfirmation: "LblAdminPaymentConfirmation",
  LblPaymentDescription: "LblPaymentDescription",
  LblPay: "LblPay",

  LblOutOf: "LblOutOf",
  // NIF Number
  LblEnableNIFNumber: "LblEnableNIFNumber",
  LblNIFNumber: "LblNIFNumber",
  LblWeGoDefault: "LblWeGoDefault"
  ,
  LblPersonActiveSuccess: "LblPersonActiveSuccess",
  LblActivate: 'LblActivate',
  LblInActiveReason: "LblInActiveReason",
  LblDefaultLanguage: 'LblDefaultLanguage',
  LblRestoreInheritConfirmation: "The current settings will be overridden by the inherited settings. Are you sure?",
  LblQestionTextRequired: "Question text required",
  LblManualSecretKey: "Secret Key",

  // Two Factor Authentication
  LblTwoFaConfig: "Two Factor Authentication",
  LblEnableTwoFa: "Enable Two Factor Authentication",
  LblExpirationDays: "Expiration Days",
  LblTextBoxExpirationDays: "expiration days",
  Lbl2FactorAuthenticateExpDays: "2FA expiration period (days):",
  LblResetCookiesWegoAdmin: "Reset cookies for all WeGo admin",
  LblReset2FactorAuthWegoAdmin: "Reset all 2FA for all WeGo admin",
  LblAuthentication: "Authentication",
  LblResetCookiesForAllAdmin: "Reset Cookies for all admin",
  LblReset2FaForAllAdmin: "Reset 2FA for all admin",
  LblEnterTotp: "Please enter code",
  LblEnterOtp: "Please enter code",
  LblSubmit: "Submit",
  LblKeyResetSuccess: "2FA Key has been reset",
  LblKeyResetFailed: "2FA Key reset failed",
  LblCookieResetSuccess: "2FA cookies has been reset",
  LblCookieResetFailed: "2FA cookies reset failed",
  LblGoogleAuthenticator: "Google Authenticator App",
  LblEmailOtpSent: "A code has been sent to your registered email address",
  LblContinue: "Continue",
  LblInvalidTOTP: "Invalid TOTP",
  LblResetCookie: "Reset Cookie",
  LblResetTwoFA: "Reset 2FA",
  LblDisableTwoFA: "Disable 2FA",
  LblTwoFaMethod: "2-Factor Method",
  LblEmailAuthentication: "Email Authentication",
  LblTwoFaMethodSelect: "You will need to verify your identity one more time. Please select your two factor authentication method",
  LblInvoicePreFix: "Invoice Prefix",
  LblEngineStillRunning: 'LblEngineStillRunning',
  LblMobileAppLink: "Mobile App Link",
  LblCountry :"Country",
  LblFileNotFound:"The File does not exist, contact the helpdesk",

  // Track & Trace
  LblTrackAndTrace: "Track & Trace",
  LblRfidTagId: "RFID Tag ID",
  LblEmployeeNumber: "Employee number",
  BtnAddVehicleInfo: "Mostrar registro de vts",

  // Access Card
  LblAccessCardId: "Access Card ID",

  LblDriversLicenseAndCertificates: "Driver's license and certificates",
  LblLicense: "Driver's license",
  LblCertificates: "Certificates",

  LblTrips: "Trips",
  LblCostsSummary: "Costs Summary",
  LblStartBooking: "Start booking",
  LblStopBooking: "Stop booking",

  LblTripHistory: "Trip history",
  LblTripStartDateTime : "From",
  LblTripEndDateTime: "To",
  LblFaZTripQuestions: "FaZ questions",
  LblNoQuestionsFound: "No FaZ questions found.",
  LblNoTripsFound: "No trips found.",
  LblTripDetails: "Trip details",
  LblUnansweredQuestions: "Unanswered Questions",
  LblNoUnansweredQuestions: "No unanswered Questions",
  LblAnswerSaved: "The answer is successfully saved",
  LblAnswerSavedError: "The answer could not be saved. Please contact the Administrator",
  LblAnswerEmptyError: "Please enter a valid answer",

  ValidatePhoneNumberVts: "Please enter valid phone number (e.g. +31623456789)",
  LblInfo: "Información",
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/shared/translate/lang-es.ts